import I18n from 'I18n';
import useMetadata from 'developer-docs-shared-components/hooks/useMetadata';
import useLocale from 'developer-docs-shared-components/hooks/useLocale';
import { useEffect, useMemo } from 'react';
import { NavMarker } from 'react-rhumb';
import { withRouter } from 'react-router-dom';
import { getUsageTracker } from '../utils/usage-tracker/index';
import styled from 'styled-components';

// @ts-expect-error No types given for file
import LoadingHOC from 'developer-docs-shared-components/lib/hoc/LoadingHOC';
import PublicH1 from 'developer-docs-shared-components/components/PublicH1';
import { mediaQueries, MOBILE_MENU_BREAKPOINT } from 'developer-docs-shared-components/utils/mediaQueries';

// @ts-expect-error No types given for file

import LayoutPublic from '../components/LayoutPublic';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ResultsPage from '../components/search/ResultsPage';
import { SEARCH_RESULTS_MAX_WIDTH } from '../components/search/constants';
import { selectSearchQuery, selectSearchResults, selectSearchStatus } from '../selectors/searchState';
import { connect, useDispatch } from 'react-redux';
import { clearSearch } from '../actions/SearchActions';
import { compose } from 'redux';
import { getSearchResultsPageUrl, searchSanitizedAndEncodedQuery } from '../components/search/searchHelpers';
import NoResultsFound from '../components/search/NoResultsFound';
import NoQueryEntered from '../components/search/NoQueryEntered';
import SearchError from '../components/search/SearchError';
import SeachPageInput from '../components/search/SearchPageInput';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Title = styled(PublicH1).withConfig({
  displayName: "SearchResultsPage__Title",
  componentId: "sc-1kd3v7s-0"
})(["margin-top:8.7vw;", "{margin-top:32px;margin-bottom:32px;}", "{padding-top:40px;}"], mediaQueries.aboveWidth(MOBILE_MENU_BREAKPOINT), mediaQueries.belowWidth(MOBILE_MENU_BREAKPOINT));
function SearchResultsPage({
  query,
  searchResults,
  loadingStatus,
  location,
  history
}) {
  const dispatch = useDispatch();
  const locale = useLocale();
  const queryParamInUrl = useMemo(() => new URLSearchParams(location.search).get('q'), [location]);
  const pageParamInUrl = useMemo(() => {
    const page = new URLSearchParams(location.search).get('page');
    return page ? parseInt(page, 10) : undefined;
  }, [location]);
  const noResultsFound = loadingStatus.succeeded && searchResults.length === 0;
  const noQueryProvided = !queryParamInUrl;

  // SRP is not indexed
  useMetadata({
    title: I18n.text('developer-docs-ui.htmlTitles.searchResultsPage'),
    description: I18n.text('developer-docs-ui.metaDescriptions.searchResultsPage'),
    noIndex: true,
    isContentLoaded: true
  });
  useEffect(() => {
    getUsageTracker().track('pageView', {
      screen: 'searchResults',
      subscreen: 'searchResults'
    });
  }, []);
  useEffect(() => {
    return () => {
      // Fired on component unmount.
      dispatch(clearSearch());
    };
  }, [dispatch]);
  useEffect(() => {
    // Handles for deep linking onto the search results page with a
    // query param or for back/forward arrow button clicks onto the search page.
    const searchNotInitiated = queryParamInUrl && !query && loadingStatus.uninitialized;
    if (searchNotInitiated) {
      searchSanitizedAndEncodedQuery(queryParamInUrl, locale, query, dispatch, false, pageParamInUrl || undefined);
      const path = getSearchResultsPageUrl(queryParamInUrl, pageParamInUrl);
      history.push(path);
    }
  }, [queryParamInUrl, query, loadingStatus, history, dispatch, pageParamInUrl, locale]);
  return /*#__PURE__*/_jsx(LayoutPublic, {
    maxContentWidth: SEARCH_RESULTS_MAX_WIDTH,
    sideNavComponent: null,
    showFeedbackForm: false,
    isSearchResultsPage: true,
    footerWidth: "full",
    children: /*#__PURE__*/_jsxs(NavMarker, {
      name: "SEARCH_PAGE_LOAD",
      children: [/*#__PURE__*/_jsx(SeachPageInput, {}), /*#__PURE__*/_jsx(Title, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "developer-docs-ui.search.header"
        })
      }), noQueryProvided ? /*#__PURE__*/_jsx(NoQueryEntered, {}) : /*#__PURE__*/_jsx(LoadingHOC, {
        statuses: [loadingStatus],
        error: /*#__PURE__*/_jsx(SearchError, {}),
        children: noResultsFound ? /*#__PURE__*/_jsx(NoResultsFound, {}) : /*#__PURE__*/_jsx(ResultsPage, {
          pageNumber: pageParamInUrl
        })
      })]
    })
  });
}
const mapStateToProps = state => ({
  query: selectSearchQuery(state),
  searchResults: selectSearchResults(state),
  loadingStatus: selectSearchStatus(state)
});
export default compose(withRouter, connect(mapStateToProps))(SearchResultsPage);